import React from "react";
import { Link } from "redux-little-router";
import "./index.css";

function UserAddCase() {
  return (
    <section className="empty-profile-wrapper">
      <h3 className="-heading-text">Publish your first Case</h3>
      <Link href="/newcase" className="button -rounded -outline -centered">
        New Case
      </Link>
    </section>
  );
}

export default UserAddCase;



// WEBPACK FOOTER //
// ./src/scenes/OthersProfile/components/UserAddCase/index.js